import { validatePremiseId } from '@dte/otw-azure-functions/src/common/util/validation/validatePremiseId';

export function getPremiseMasterDataURL(premiseId: string | undefined): string | undefined {
	const premiseIdValue = validatePremiseId(premiseId, false);
	if (!premiseIdValue) {
		return undefined;
	}

	return `/authenticated/data/premises/${premiseIdValue}/masterData`;
}
